import { render, staticRenderFns } from "./ArtisanGridRowBtn.vue?vue&type=template&id=2a9c7898"
import script from "./ArtisanGridRowBtn.vue?vue&type=script&lang=js"
export * from "./ArtisanGridRowBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports